import * as Preact from "preact"

const dom = document.getElementById("mount")

import View from "@frog/source/views/Mount.jsx"

let view = undefined

export default function() {
    view = Preact.render(Preact.h(View), dom, view)
}
